// extracted by mini-css-extract-plugin
export var notificationHost = "_lh-0";